
export const calculateNextPeriod = (lastPeriodDate: Date, cycleLength: string) => {
  const nextDate = new Date(lastPeriodDate);
  nextDate.setDate(nextDate.getDate() + parseInt(cycleLength));
  return nextDate;
};

export const calculatePhase = (lastPeriodDate: Date, cycleLength: string, periodDuration: string) => {
  const today = new Date();
  // Normaliser les dates pour éviter les problèmes de fuseau horaire
  today.setHours(0, 0, 0, 0);
  const normalizedLastPeriod = new Date(lastPeriodDate);
  normalizedLastPeriod.setHours(0, 0, 0, 0);
  
  const daysSinceLastPeriod = Math.floor(
    (today.getTime() - normalizedLastPeriod.getTime()) / (1000 * 60 * 60 * 24)
  );
  
  console.log('Phase calculation:', {
    today: today.toISOString(),
    lastPeriodDate: normalizedLastPeriod.toISOString(),
    daysSinceLastPeriod,
    cycleLength,
    periodDuration
  });
  
  const cycleLengthNum = parseInt(cycleLength);
  const currentCycleDay = ((daysSinceLastPeriod % cycleLengthNum) + cycleLengthNum) % cycleLengthNum + 1;
  
  console.log('Current cycle day:', currentCycleDay);

  // Si la date est dans le futur, aucune phase n'est active
  if (normalizedLastPeriod > today) {
    return {
      phase: "NOT_STARTED",
      color: "#E2E8F0",
      description: "Cycle non commencé",
      active: false
    };
  }
  
  if (currentCycleDay <= parseInt(periodDuration)) {
    return {
      phase: "MENSTRUATION",
      color: "#E6B3CC",
      description: "Phase menstruelle",
      active: true
    };
  } else if (currentCycleDay <= 11) {
    return {
      phase: "INFERTILE DAYS",
      color: "#8DD4E6",
      description: "Jours infertiles",
      active: true
    };
  } else if (currentCycleDay <= 19) {
    return {
      phase: "FERTILE DAYS",
      color: "#90EE90",
      description: "Jours fertiles",
      active: true
    };
  } else {
    return {
      phase: "INFERTILE DAYS",
      color: "#E6D5BA",
      description: "Jours infertiles",
      active: true
    };
  }
};

export const calculateCurrentDay = (lastPeriodDate: Date, cycleLength: string) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const normalizedLastPeriod = new Date(lastPeriodDate);
  normalizedLastPeriod.setHours(0, 0, 0, 0);
  
  const daysSinceLastPeriod = Math.floor(
    (today.getTime() - normalizedLastPeriod.getTime()) / (1000 * 60 * 60 * 24)
  );
  
  console.log('Current day calculation:', {
    today: today.toISOString(),
    lastPeriodDate: normalizedLastPeriod.toISOString(),
    daysSinceLastPeriod,
    cycleLength,
    currentDay: ((daysSinceLastPeriod % parseInt(cycleLength)) + parseInt(cycleLength)) % parseInt(cycleLength) + 1,
    timeDiff: today.getTime() - normalizedLastPeriod.getTime()
  });
  
  const cycleLengthNum = parseInt(cycleLength);
  return ((daysSinceLastPeriod % cycleLengthNum) + cycleLengthNum) % cycleLengthNum + 1;
};

export const getDayColor = (
  day: number,
  currentPhase: { phase: string; color: string; description: string; active: boolean } | null
) => {
  if (!currentPhase) return "#E2E8F0"; // Default color if no phase
  return currentPhase.active ? currentPhase.color : "#E2E8F0";
};
